import Communications from './Communications';

export default Communications;